import { AlignTypes } from "@monorepo-web/components-library";
const getColunasPosCon = (datas, headerPercent) => {
    var _a, _b, _c, _d;
    return ({
        nomeAtivo: {
            id: "nome_ativo",
            label: "Ativo",
            colorLegend: true,
            freeze: true,
            width: "300px",
            noBreak: true,
        },
        saldoBrutoIni: {
            id: "sbr_ini",
            label: `Saldo Bruto ${(_b = (_a = datas === null || datas === void 0 ? void 0 : datas.data_ini) === null || _a === void 0 ? void 0 : _a.split("-").reverse().join("/")) !== null && _b !== void 0 ? _b : " Início"}`,
            align: AlignTypes.right,
            headerAlign: AlignTypes.center,
        },
        aplicacoes: {
            id: "apl",
            label: "Aplicações no período",
            align: AlignTypes.right,
            headerAlign: AlignTypes.center,
        },
        resgates: {
            id: "res",
            label: "Resgates no período",
            align: AlignTypes.right,
            headerAlign: AlignTypes.center,
        },
        eventos: {
            id: "evento",
            label: "Eventos",
            align: AlignTypes.right,
            headerAlign: AlignTypes.center,
        },
        saldoBrutoFim: {
            id: "sbr_fim",
            label: `Saldo Bruto ${(_d = (_c = datas === null || datas === void 0 ? void 0 : datas.data_fim) === null || _c === void 0 ? void 0 : _c.split("-").reverse().join("/")) !== null && _d !== void 0 ? _d : " Fim"}`,
            align: AlignTypes.right,
            headerAlign: AlignTypes.center,
        },
        rendimentoBruto: {
            id: "rendimento",
            label: "Rendimento Bruto",
            align: AlignTypes.right,
            headerAlign: AlignTypes.center,
        },
        impostos: {
            id: "imposto_pago",
            label: "Impostos Pagos",
            align: AlignTypes.right,
            headerAlign: AlignTypes.center,
        },
        provisao: {
            id: "provisao_IR_IOF",
            label: "Provisão IR+IOF",
            align: AlignTypes.right,
            headerAlign: AlignTypes.center,
        },
        saldoLiquido: {
            id: "sli_fim",
            label: "Saldo Líquido",
            align: AlignTypes.right,
            headerAlign: AlignTypes.center,
        },
        percentSli: {
            id: "percent_sli",
            label: headerPercent !== null && headerPercent !== void 0 ? headerPercent : "%",
            align: AlignTypes.right,
        },
    });
};
const getColunasRetAtivo = () => ({
    nomeAtivoReduzido: {
        id: 'nome_ativo',
        label: 'Ativo',
        colorLegend: true,
        freeze: true,
        noBreak: true,
    },
    saldoBruto: {
        id: "Saldo_bruto",
        label: "Saldo Bruto",
        align: AlignTypes.right,
    },
    saldoBrutoRetAtivo: {
        id: 'sbr_fim',
        label: 'Saldo Bruto',
        align: AlignTypes.right,
    },
    retMes: {
        id: "Ret_Mes",
        label: "Mês",
        align: AlignTypes.right,
    },
    retAno: {
        id: "Ret_Ano",
        label: "Ano",
        align: AlignTypes.right,
    },
    ret3M: {
        id: "Ret_3m",
        label: "3 meses",
        align: AlignTypes.right,
    },
    ret6M: {
        id: "Ret_6m",
        label: "6 meses",
        align: AlignTypes.right,
    },
    ret12M: {
        id: "Ret_12m",
        label: "12 meses",
        align: AlignTypes.right,
    },
    ret24M: {
        id: "Ret_24m",
        label: "24 meses",
        align: AlignTypes.right,
    },
    ret36M: {
        id: "Ret_36m",
        label: "36 meses",
        align: AlignTypes.right,
    },
    retPeriodo: {
        id: "Ret_periodo",
        label: "Desde a compra",
        align: AlignTypes.right,
    },
    retPeriodoReduzido: {
        id: "Ret_periodo",
        label: "Desde o Início",
        align: AlignTypes.right,
    },
    dataCompra: {
        id: "data_compra",
        label: "Data Compra",
        align: AlignTypes.right,
    },
});
const getColunasCartExp = () => ({
    nomeAtivoFinal: {
        id: "nome_ativo",
        label: "Ativo Final",
        colorLegend: true,
        freeze: true,
        width: "300px",
        noBreak: true,
    },
    saldoBrutoCartExp: {
        id: "sbr_fim",
        label: `Saldo Bruto`,
        align: AlignTypes.right,
        headerAlign: AlignTypes.right,
    },
    percentSaldoBruto: {
        id: "percent_sbr",
        label: "% do Saldo Bruto",
        align: AlignTypes.right,
        headerAlign: AlignTypes.right,
    },
});
export const getLayouts = (datas, headerPercent) => {
    const colsPosCon = getColunasPosCon(datas, headerPercent);
    const colsRetAtivo = getColunasRetAtivo();
    const colsCartExp = getColunasCartExp();
    return {
        default: [
            colsPosCon.nomeAtivo,
            colsPosCon.saldoBrutoIni,
            colsPosCon.aplicacoes,
            colsPosCon.resgates,
            colsPosCon.eventos,
            colsPosCon.saldoBrutoFim,
            colsPosCon.rendimentoBruto,
            colsPosCon.impostos,
            colsPosCon.provisao,
            colsPosCon.saldoLiquido,
            colsPosCon.percentSli,
        ],
        retorno_ativo: [
            colsPosCon.nomeAtivo,
            colsRetAtivo.retMes,
            colsRetAtivo.retAno,
            colsRetAtivo.ret3M,
            colsRetAtivo.ret6M,
            colsRetAtivo.ret12M,
            colsRetAtivo.ret24M,
            colsRetAtivo.ret36M,
            colsRetAtivo.retPeriodo,
            colsRetAtivo.dataCompra,
            colsPosCon.percentSli,
        ],
        retorno_ativo_reduzido: [
            colsRetAtivo.nomeAtivoReduzido,
            colsRetAtivo.retMes,
            colsRetAtivo.retAno,
            colsRetAtivo.ret12M,
            colsRetAtivo.retPeriodoReduzido,
            colsRetAtivo.saldoBruto,
            colsPosCon.percentSli,
        ],
        retorno_ativo_saldo_bruto: [
            colsPosCon.nomeAtivo,
            colsPosCon.percentSli,
            colsRetAtivo.saldoBrutoRetAtivo,
            colsRetAtivo.retMes,
            colsRetAtivo.retAno,
            colsRetAtivo.ret3M,
            colsRetAtivo.ret6M,
            colsRetAtivo.ret12M,
            colsRetAtivo.ret24M,
            colsRetAtivo.ret36M,
            colsRetAtivo.retPeriodo,
            colsRetAtivo.dataCompra,
        ],
        carteira_explodida: [
            colsCartExp.nomeAtivoFinal,
            colsCartExp.saldoBrutoCartExp,
            colsCartExp.percentSaldoBruto,
        ],
    };
};
export const getLayoutsConfigTable = () => ({
    default: {},
    retorno_ativo: {},
    retorno_ativo_reduzido: {
        lineBreak: false,
        headerFixed: false,
    },
    retorno_ativo_saldo_bruto: {},
    carteira_explodida: {},
});
